/* dt-perf v1 - keeps the idle main thread quiet without removing any animation.
   1. Sections scrolled off screen pause their CSS animations (resume on return).
   2. Infinite animations of main-thread-only properties (box-shadow, left, background-position,
      stroke-dashoffset...) play in synchronized bursts instead of forever, so the page stops
      repainting between bursts. transform/opacity animations run on the GPU and are left alone. */
(function () {
  if (window.__dtPerf) return;
  window.__dtPerf = 1;
  var D = document;

  // 1. off-screen gate
  if ('IntersectionObserver' in window) {
    var st = D.createElement('style');
    st.textContent = '.dt-anim-off,.dt-anim-off *,.dt-anim-off *::before,.dt-anim-off *::after{animation-play-state:paused!important}';
    D.head.appendChild(st);
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) es[i].target.classList.toggle('dt-anim-off', !es[i].isIntersecting);
    }, { rootMargin: '150px 0px' });
    var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
    var gate = function () {
      if (!seen) return;
      var n = D.querySelectorAll('#MainContent > *, #MainContent > .shopify-section > *, .shopify-section-group-footer-group');
      for (var i = 0; i < n.length; i++) {
        var el = n[i];
        if (seen.has(el)) continue;
        seen.add(el);
        var pos = getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky' || el.querySelector('#dt-header')) continue;
        io.observe(el);
      }
      // long sections (guide articles) stay "on screen" as a whole, so also watch each looping element itself
      if (!D.getAnimations) return;
      var list = D.getAnimations();
      for (var j = 0; j < list.length; j++) {
        var a = list[j], t = a.effect && a.effect.target;
        if (!t || seen.has(t) || !a.effect.getTiming || a.effect.getTiming().iterations !== Infinity) continue;
        seen.add(t);
        if (t.closest && t.closest('.dtf,#dt-header')) continue; // fixed launcher / sticky header: always visible
        io.observe(t);
      }
    };
  }

  // 2. burst limiter
  if (!D.getAnimations || !window.Animation) return init();
  var GPU = { transform: 1, opacity: 1, translate: 1, scale: 1, rotate: 1, filter: 1, offset: 1, easing: 1, composite: 1, computedOffset: 1 };
  var TICK = 12000, BURST_MAX = 4000;
  var cpuOnly = function (a) {
    var el = a.effect.target;
    // SVG transforms are never GPU-composited; the always-on Finder launcher repaints on every page
    if (el && (el instanceof SVGElement || (el.closest && el.closest('.dtf')))) return true;
    try {
      var kf = a.effect.getKeyframes();
      for (var i = 0; i < kf.length; i++) for (var p in kf[i]) if (!GPU[p]) return true;
    } catch (e) {}
    return false;
  };
  var tamed = typeof WeakSet === 'function' ? new WeakSet() : null;
  var burst = function (first) {
    if (D.hidden) return;
    var list = D.getAnimations();
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      if (!a.effect || !a.effect.getTiming) continue;
      var t = a.effect.getTiming();
      var known = tamed && tamed.has(a);
      if (!known && (t.iterations !== Infinity || !cpuOnly(a))) continue;
      var dur = typeof t.duration === 'number' ? t.duration : 0;
      if (!dur) continue;
      if (!known) { tamed && tamed.add(a); }
      // one burst = as many whole cycles as fit in BURST_MAX (at least one)
      var n = Math.max(1, Math.floor(BURST_MAX / dur));
      if (first) { a.effect.updateTiming({ iterations: n }); continue; } // cap the current run; never force-play
      var el = a.effect.target;
      if (!el || !el.getBoundingClientRect || (el.closest && el.closest('.dt-anim-off'))) continue; // gated off screen
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight || (!r.width && !r.height)) continue;
      if (a.playState === 'running') continue;
      a.effect.updateTiming({ iterations: n, delay: 0 });
      a.currentTime = 0;
      a.play();
    }
  };
  function init() {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var s = D.createElement('style');
      s.textContent = '*,*::before,*::after{animation-iteration-count:1!important}';
      D.head.appendChild(s);
    }
    gate && gate();
    if (D.getAnimations && window.Animation) {
      setTimeout(function () { burst(true); }, 1500);
      setInterval(function () { burst(false); }, TICK);
      D.addEventListener('visibilitychange', function () { if (!D.hidden) burst(false); });
    }
    setTimeout(function () { gate && gate(); }, 3000); // late-injected sections
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
